import type { FragmentType } from 'src/gql';
import { graphql, unmaskFragment } from 'src/gql';
import { assetTitle, renderIconForAsset } from 'src/utils/asset';

import { assetSubtitle } from '@savvy/deprecated-shared/utils/portfolio';

import NetWorthItemDescriptionRow from './views/net-worth-item-description-row';

export const NetWorthAssetDescriptionRowFragment = graphql(/* GraphQL */ `
  fragment NetWorthAssetDescriptionRow on Asset {
    ...AssetTitle
    ...RenderIconForAsset
    assetClass
    assetSubclass
    companyEquityCompanyName
    companyEquityGrantType
    description
  }
`);

export default function NetWorthAssetDescriptionRow({
  assetFrag,
}: {
  readonly assetFrag: FragmentType<typeof NetWorthAssetDescriptionRowFragment>;
}) {
  const asset = unmaskFragment(NetWorthAssetDescriptionRowFragment, assetFrag);
  return (
    <NetWorthItemDescriptionRow
      icon={renderIconForAsset(asset)}
      subtitle={assetSubtitle(asset)}
      title={assetTitle(asset)}
    />
  );
}
